import { Tooltip } from "flowbite-react"
import * as Iconoir from "iconoir-react"
import React from "react"

interface TourTriggerProps {
  onClick: (event: React.MouseEvent<HTMLDivElement>) => void
  tooltipContent: string
  className?: string
}

const TourTrigger: React.FC<TourTriggerProps> = ({ onClick, tooltipContent, className }) => {
  return (
    <Tooltip content={tooltipContent}>
      <div
        onClick={onClick}
        className={`p-1.5 text-gray-400 hover:text-purple-600 hover:bg-purple-50 rounded-lg transition-colors ${className}`}
        aria-label={tooltipContent}
      >
        <Iconoir.HelpCircle className="w-5 h-5" />
      </div>
    </Tooltip>
  )
}

export default TourTrigger
